import { render, staticRenderFns } from "./CreatePermanentFundraiser.vue?vue&type=template&id=9ff6d8fc&scoped=true&"
import script from "./CreatePermanentFundraiser.vue?vue&type=script&lang=js&"
export * from "./CreatePermanentFundraiser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff6d8fc",
  null
  
)

export default component.exports